/**
 * M&B Club minicart A/B test (Intelligems).
 * Decides, per visitor, which M&B Club widget the minicart shows, which tag VIP-discounted items get,
 * and whether the membership shows as its own cart line. Docs: docs/mb-club-experiment.md
 * Preview a group with Intelligems: add ?ig-preview=<experimentId> to any URL.
 *
 * Loaded before the widget scripts and side-cart.js (snippets/side-cart.liquid).
 */
window.MB_CLUB_EXPERIMENT = {
  // false = the test doesn't route anyone: every visitor gets `fallback`.
  enabled: true,

  // Intelligems experiment id. Change it here if the test is recreated.
  experimentId: 'c653745d-d8ae-4fbb-a9dd-cabd1a382452',

  // One entry per Intelligems test group. A visitor's group matches by `testGroupId` when it's set,
  // otherwise by the start of the group name in Intelligems (e.g. "V2: M&B Club TC" starts with "V2:").
  //   widget:             'v1' current widget | 'v2' new design above the subtotal | 'none' no widget
  //   tag:                'v1' green "VIP" arrow | 'v2' "M&B Club −15%" pill
  //   showMembershipLine: true = the membership shows as its own line in the minicart (not hidden)
  groups: {
    control:   { name: 'C:',  testGroupId: '', widget: 'none', tag: 'v1', showMembershipLine: false }, // C: No M&B Club
    classic:   { name: 'V1:', testGroupId: '', widget: 'v1',   tag: 'v1', showMembershipLine: false }, // V1: M&B Club one-time
    newDesign: { name: 'V2:', testGroupId: '', widget: 'v2',   tag: 'v2', showMembershipLine: true },  // V2: M&B Club TC
  },

  // Visitors outside the test (not assigned, test disabled, Intelligems blocked or too slow): today's
  // minicart, i.e. the V1 widget still behind its older show/hide experiment (theme settings).
  fallback: { widget: 'v1', tag: 'v1', showMembershipLine: false },

  // How long to wait for Intelligems before using `fallback`.
  intelligemsTimeoutMs: 4000,
};

// ---- No need to edit below this line ----
(function () {
  const config = window.MB_CLUB_EXPERIMENT;

  const withMeta = (settings, meta) => Object.assign({}, settings, meta);
  const fallback = (reason) => withMeta(config.fallback, { assigned: false, group: null, reason });

  function variantFromIntelligems() {
    const testGroup = window.igData?.user?.getTestGroup?.(config.experimentId);
    if (!testGroup) return fallback('not in the test');
    const name = (testGroup.name || '').trim().toLowerCase();
    const key = Object.keys(config.groups).find((groupKey) => {
      const group = config.groups[groupKey];
      return group.testGroupId ? group.testGroupId === testGroup.id : name.startsWith(group.name.toLowerCase());
    });
    if (!key) {
      console.warn('[mb-club-experiment] no group in MB_CLUB_EXPERIMENT matches', testGroup.name, testGroup.id);
      return fallback('unmatched test group');
    }
    return withMeta(config.groups[key], {
      assigned: true,
      group: key,
      testGroup: { id: testGroup.id, name: testGroup.name, isControl: !!testGroup.isControl },
    });
  }

  function decide() {
    if (!config.enabled) return Promise.resolve(fallback('test disabled'));
    return new Promise((resolve) => {
      if (window.igData?.user?.getTestGroup) {
        resolve(variantFromIntelligems());
        return;
      }
      const timer = setTimeout(() => resolve(fallback('Intelligems not ready')), config.intelligemsTimeoutMs);
      window.addEventListener('ig:ready', () => {
        clearTimeout(timer);
        resolve(variantFromIntelligems());
      }, { once: true });
    });
  }

  // Until the decision, the minicart uses the fallback tag and keeps the membership line hidden
  window.mbMemberTagVersion = config.fallback.tag;
  window.mbMembershipLineVisible = config.fallback.showMembershipLine;

  const ready = decide().then((variant) => {
    window.mbClubExperiment.variant = variant;
    window.mbMemberTagVersion = variant.tag;
    window.mbMembershipLineVisible = variant.showMembershipLine;
    document.querySelector('side-cart')?.applyMbClubVariant?.();
    if (variant.testGroup) {
      // Same localStorage key the GTM tags already read for the M&B Club widget test
      try {
        localStorage.setItem('vip-ig-experiment', JSON.stringify({
          experimentId: config.experimentId,
          variant: variant.testGroup.isControl ? 'control' : 'variant',
          group: variant.testGroup.name,
        }));
      } catch (error) {
        console.warn('[mb-club-experiment] Failed to save the assignment to localStorage:', error);
      }
    }
    console.log('[mb-club-experiment]', variant.group || 'fallback', `(${variant.reason || variant.testGroup?.name})`, variant);
    return variant;
  });

  window.mbClubExperiment = {
    enabled: config.enabled,
    experimentId: config.experimentId,
    variant: null, // set once decided: { widget, tag, showMembershipLine, assigned, group, ... }
    ready,
    // Runs `callback` once the variant is decided, only when it shows this widget version
    whenWidget(version, callback) {
      ready.then((variant) => {
        if (variant.widget === version) callback(variant);
      });
    },
  };
})();
